import * as rootObject from './';
import details from './details';
import history from './history';

const DETAULT_TOTALS =  {
	units: 0,
	distance: 0,
	sub_total: 0,
	fuel_economy: 0
}

const filterRecords = (records,start,end) => {
	start = new Date(start)
	end = new Date(end)
	const fn = record => { 
		const tDate = new Date(record.date)
		return tDate>=start  &&  tDate<=end
	}
	return records.filter(fn)
}
const getFilteredList = (state=[], action) => {
	switch(action.filter){
		case 'SHOW_ALL':
			return state;
		case 'SHOW_LAST_FILLUP':
			return state.length ? [state[state.length-1]] : [];
		default:
			return filterRecords(state,action.start,action.end);
	}
}

const calcTotals = (records, starting) => {
	let newTotals = Object.assign({},DETAULT_TOTALS)
	records.map(record => {
		newTotals.units = trimFloat(newTotals.units + record.units,3)
		newTotals.sub_total = trimFloat(newTotals.sub_total + record.sub_total,2)
		return record;
	})
		newTotals.distance = trimFloat((records[records.length-1] || {odometer:starting}).odometer-starting,1)
		newTotals.fuel_economy = parseInt( newTotals.distance / newTotals.units ) || 0
	return newTotals
}

const getStartingOdometer = (car, sub)=>{
	let result = car.details.starting_odometer;
	const first_record = sub[0];
	if(first_record){
		const matches = filterRecords(car.history.records,0,new Date(first_record.date)-1 );
		const record_zero = matches[matches.length-1];
		if(record_zero){
			result = record_zero.odometer;
		}
	}
	return result;
}

const trimFloat = (f,n) => parseFloat(f.toFixed(n))


export const getTotalsArray = (state) => {
	const Cars = rootObject.getCars(state);
	let theCar;
	let result = []
	for(let car in Cars){
		theCar = Cars[car];
		
		let filtered_records = getFilteredList(
			theCar.history.records,
			theCar.history.filter
		);

		result.push(
			Object.assign({label:car}, calcTotals(filtered_records,getStartingOdometer(theCar, filtered_records)) )
		)
	}
	return result;
}

export default (state={}, action) => {
	let newState = {... state};
	let result;
	switch(action.type){
		case 'INIT':
		newState = {};
			for(let car in action.cars){
				newState[car] = {
					details: Object.assign(details(undefined, action), action.cars[car].details),
					history: Object.assign(history(undefined, action), action.cars[car].history)
				}
			}
			return newState;

		case "NEW_VEHICLE":
			const INSERT = !newState[action.label];

			//ALWAYS PERFORM THIS ACTION ON INSERT or UPDATE
			result = {
				[action.label]: {
					details: details(undefined, action)
				}
			}

			if(INSERT){ //ON INSERT
				result[action.label].history = history(undefined, action);
			} else { //ON UPDATE
				result[action.label].history = newState[action.label].history
			}

			return Object.assign(newState,result);
		
		case "BLANK_VEHICLE":
			result = {
				[action.label]: {
					details: details(newState.details, action),
					//history: history(newState.history, action)
				}
			}

			return Object.assign(newState,result);
		
		case "ADD_FILLUP":
			let car = newState[action.vehicle];
			Object.assign(car, {history:history(car.history, action)});
			return newState;

		case "SET_VISIBILITY_FILTER":
			newState[action.car].history = history(state[action.car].history, action)
			return newState;

		case "SIGN_OUT":
			return {};	

		default:
			return newState;
	}
}


// WEBPACK FOOTER //
// ./src/reducers/cars.js